export const roomsKeys = {
  all: ['rooms'] as const,
  list: () => [...roomsKeys.all, 'list'] as const,
  details: (roomId: number) => [...roomsKeys.all, roomId, 'detail'] as const,
};
